import { useCurrentUser } from '../../../shared/hooks/useCurrentUser';
import { visibleNavSections, type NavSection } from '../../../shared/config/routes';
import { usePipelineContext } from './usePipelineContext';

/**
 * Разделы меню для текущего человека, или `null`, пока роль неизвестна.
 *
 * `null` — не мелочь. Пока отделения не приехали, человек выглядит как «нет
 * ролей», а это значит «показать всё». Монтажёр увидел бы «Статистику» и
 * «Аккаунты» на одно мгновение, а корень приложения успел бы увести его
 * именно туда — что и происходило до этой правки. Поэтому меню и переход с
 * «/» ждут ответа, а не гадают по пустому состоянию.
 */
export function useVisibleNavSections(): NavSection[] | null {
  const { isAdmin } = useCurrentUser();
  const { context, divisions, error } = usePipelineContext();

  // Готовность определяем по наличию ответа, а не по флагу загрузки: на
  // первом рендере запрос ещё не стартовал, `isLoading` там false, и меню
  // успевало посчитаться по пустым отделениям. Именно так монтажёр и уезжал
  // в «Статистику» с корня приложения.
  //
  // Запрос упал — не запираем человека без меню: возвращаем то, что было до
  // отделений. Ограничение доступа живёт на сервере и от меню не зависит.
  if (!context && !error) return null;

  return visibleNavSections({
    isAdmin,
    divisionRoles: divisions.map((division) => division.role),
  });
}
